// extracted by mini-css-extract-plugin
export var animating = "_2w-3";
export var background = "_2w-6";
export var constrainHeight = "_2w-2";
export var dark = "_2w-4";
export var dropdown = "_2w-1";
export var leave = "_2w-5";
export var option = "_2w-7";
export var root = "_2w-0";